import React, { useCallback } from 'react'
import { injectIntl, FormattedMessage } from 'react-intl'
import { LAYOUT_NAME_MAX_LENGTH } from 'const/limits'
import {
  LeftSidebarView,
  ViewBody
} from 'components/Sidebar'
import withLeftSidebar from 'components/Sidebar/withLeftSidebar'
import CopyLayoutForm from './CopyLayoutForm'
import { useHistory } from 'react-router'

export function CopyLayout ({
  layoutId,
  layoutName,
  layoutIsTemplate,
  addToMyHomeLayout = false,

  intl,
  leftSidebar,

  requestCopyLayout,
}) {
  const history = useHistory()

  const handleValidate = useCallback(({ name }) => {
    const errors = {}
    if (name && name.length > LAYOUT_NAME_MAX_LENGTH) {
      errors.name = intl.formatMessage({ id: 'CARD_NAME_TOO_LONG' }, { limit: LAYOUT_NAME_MAX_LENGTH })
    }
    return errors
  }, [intl])

  const handleSubmit = useCallback(({ name }) => {
    if (name) {
      requestCopyLayout({
        layoutId,
        name,
        position: addToMyHomeLayout ? 0 : undefined,
        onSuccess: ({ Id }) => {
          history.push(`/home/${Id}`)

          leftSidebar.close()
        }
      })

      leftSidebar.close()
    }
  }, [addToMyHomeLayout, layoutId, leftSidebar, requestCopyLayout, history])

  return (
    <LeftSidebarView
      title={<FormattedMessage id={layoutIsTemplate ? 'DESK_TEMPLATE_COPY_HEADER' : 'DESK_COPY_HEADER'} values={{ name: layoutName }} />}
    >
      <ViewBody>
        <CopyLayoutForm
          validate={handleValidate}
          onSubmit={handleSubmit}
          initialValues={{
            name: layoutName
          }}
        />
      </ViewBody>
    </LeftSidebarView>
  )
}

export default injectIntl(withLeftSidebar(CopyLayout))
